import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

/**
 * 廣告管理元件，根據當前頁面路徑決定是否載入 AdSense 廣告（GA 見 utils/analytics.js）
 * 當路徑包含 /members/ 或 /admin 時不顯示廣告
 */
const AdManager = () => {
  const location = useLocation();
  const [previousPath, setPreviousPath] = useState('');
  
  // Google AdSense 管理
  useEffect(() => {
    // 檢查當前路徑是否為應該禁用廣告的頁面
    const shouldDisableAds = 
      location.pathname.includes('/members/') || 
      location.pathname.includes('/admin');
    
    const previouslyDisabledAds = 
      previousPath.includes('/members/') || 
      previousPath.includes('/admin');
    
    // 如果廣告顯示狀態需要變化，則進行處理
    if (shouldDisableAds !== previouslyDisabledAds || previousPath === '') {
      // 更新前一個路徑記錄
      setPreviousPath(location.pathname);
      
      // 處理 AdSense 腳本
      if (shouldDisableAds) {
        // 進入禁用廣告頁面 - 移除廣告腳本
        hideAds();
      } else {
        // 離開禁用廣告頁面 - 顯示廣告腳本
        showAds();
      }
    }
  }, [location.pathname, previousPath]);
  
  // 隱藏廣告的函數
  const hideAds = () => {
    // 隱藏現有的 AdSense 廣告
    const adElements = document.querySelectorAll('.adsbygoogle, [id^="google_ads"]');
    adElements.forEach(el => {
      if (el && el.style) {
        el.style.display = 'none';
      }
    });
    
    // 移除 AdSense 腳本
    const existingScript = document.querySelector('script[src*="adsbygoogle.js"]');
    if (existingScript) {
      existingScript.remove();
    }
    
    // 標記頁面不顯示廣告
    document.body.setAttribute('data-ads-disabled', 'true');
  };
  
  // 顯示廣告的函數
  const showAds = () => {
    // 移除不顯示廣告的標記
    document.body.removeAttribute('data-ads-disabled');
    
    // 檢查 AdSense 腳本是否已存在
    const existingScript = document.querySelector('script[src*="adsbygoogle.js"]');
    if (!existingScript) {
      // 動態載入 AdSense 腳本
      const script = document.createElement('script');
      script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3647850156868807';
      script.async = true;
      script.crossOrigin = 'anonymous';
      document.head.appendChild(script);
      
      // 腳本載入完成後重新初始化廣告
      script.onload = () => {
        // 顯示之前被隱藏的廣告
        const adElements = document.querySelectorAll('.adsbygoogle');
        adElements.forEach(el => {
          if (el && el.style) {
            el.style.display = 'block';
          }
          
          // 嘗試重新初始化廣告
          try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
          } catch (error) {
            console.error('AdSense 重新初始化失敗:', error);
          }
        });
      };
    } else {
      // 如果腳本已存在，直接顯示廣告
      const adElements = document.querySelectorAll('.adsbygoogle');
      adElements.forEach(el => {
        if (el && el.style) {
          el.style.display = 'block';
        }
      });
    }
  };
  
  // 初始檢查
  useEffect(() => {
    // 頁面首次載入時的處理
    const shouldDisableAds = 
      location.pathname.includes('/members/') || 
      location.pathname.includes('/admin');
      
    if (shouldDisableAds) {
      hideAds();
    } else {
      showAds();
    }
    
    // 清理函數
    return () => {
      // 此處不移除任何腳本，因為我們希望在不同路由之間保持腳本的狀態
    };
  }, [location.pathname]);

  // 此元件不渲染任何內容，僅管理廣告腳本
  return null;
};

export default AdManager;